









































import { Component, Vue, Watch } from "vue-property-decorator";
import CompanyCard from "../components/CompanyCard.vue";
import ContentCard from "../components/ContentCard.vue";
import FilterChip from "../components/FilterChip.vue";
import MobileContent from "../components/MobileContent.vue";
import TabletContent from "../components/TabletContent.vue";
import DesktopContent from "../components/DesktopContent.vue";
import { CompanyDetail } from "@authentic-labs/vue-component-library";

import { Circle2 } from "vue-loading-spinner";

@Component({
  components: {
    CompanyCard,
    ContentCard,
    FilterChip,
    MobileContent,
    CompanyDetail,
    Circle2,
    TabletContent,
    DesktopContent,
  },
})
export default class CompanyContent extends Vue {
  @Watch("windowWidth")
  onPropertyChanged(value: string, oldValue: string) {
    if (this.windowWidth <= 768 && this.windowWidth >= 576) {
      this.isTablet = true;
    } else {
      this.isTablet = false;
    }
    if (this.windowWidth < 576) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  }

  get company() {
    return this.$store.getters.company;
  }

  isTablet = false;
  isMobile = false;
  windowWidth = window.innerWidth;
  isLoading = true;

  async mounted() {
    this.isLoading = true;
    window.innerWidth <= 768 && window.innerWidth > 576
      ? (this.isTablet = true)
      : (this.isTablet = false);
    window.innerWidth < 576 ? (this.isMobile = true) : (this.isMobile = false);
    window.addEventListener("resize", () => {
      this.windowWidth = window.innerWidth;
    });

    this.$store.commit("setCompany", []);
    const companyId = this.$route.params.companyId as string;
    await this.$store.dispatch("getCompany", companyId);
    this.isLoading = false;
  }
}
